<template>
  <div class="pa-lg-3 neu-glow mt-lg-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card  ref="scrollContainer" class="scroll-container pb-5">
          <v-card-title primary-title>
            <v-spacer></v-spacer>
            <div>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop="saveTemplate()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon  fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>              
            </div>           
          </v-card-title>
          <v-row v-if="loading||!WA_DB">
            <v-col class="text-center">
              <v-progress-linear
                color="info"
                height="10"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
          </v-row>          
          <v-row v-else class="mx-lg-5">
            <!--<masonry-wall :items="classes"  scroll-container="scrollContainer" :gap="16" class="mx-4">-->
            <v-col cols="12" lg="6" class="order-0 order-xl-0">
              <v-card class="neu-glow" :class="$vuetify.breakpoint.lgAndUp?' mb-3':' my-3'">
                <v-card-title class="text-h5 blue-grey darken-1 pb-3 mb-3">
                  Parametri Form Prenotazione Online
                </v-card-title>
                <template v-for="(group, gi) in WA_DB_grouped">
                  <v-card outlined :key="'grp_db'+gi" class="ma-1 py-3">
                  <v-row class="mx-2" v-for="(i,ii) in group.items" :key="group.path+'_'+ii">
                  <v-col cols="11" v-if="i.dataType=='nvarchar'" class="d-flex align-center">  
                      <v-textarea 
                        v-if="i.inputType=='textarea'"
                        counter
                        :label="i.description"
                        :name="i.optionId"
                        @input.native="save"
                        outlined
                        auto-grow
                        :reverse="i.dataType!='nvarchar'"
                        v-model="i.value"
                        persistent-placeholder
                        hide-details
                        :readonly="!i.editableByUser"
                      >
                      </v-textarea>
                      <v-select
                        v-else-if="i.inputType=='select'"
                        :label="i.description"
                        :name="i.optionId"
                        :items="i.acceptedValues ? i.acceptedValues.split(',').map(v => v.trim()) : []"
                        v-model="i.value"
                        outlined
                        dense
                        hide-details
                        :readonly="!i.editableByUser"
                        @change="save2($event, i.optionId)"
                      ></v-select>
                        <v-select
                          v-else-if="i.inputType=='multiselect'"
                          v-model="i.value"
                          :items="i.acceptedValues ? i.acceptedValues.split(',').map(v => v.trim()) : []"
                          :multiple="i.inputType === 'multiselect'"
                          :chips="i.inputType === 'multiselect'"
                          :small-chips="i.inputType === 'multiselect'"
                          outlined
                          dense
                          hide-details
                          :readonly="!i.editableByUser"
                          :name="i.optionId"
                          @change="save2(Array.isArray($event) ? $event.join(',') : $event, i.optionId)"
                        >
                        </v-select>

                      <v-menu
                        v-else-if="i.inputType=='date' || i.inputType=='datetime' || i.inputType=='time'"
                        :ref="'menu_'+i.optionId"
                        v-model="i._menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        :disabled="!i.editableByUser"
                        eager
                      >
                        <template v-slot:activator="{ attrs }">
                          <v-text-field
                            v-model="i.value"
                            :label="i.description"
                            :name="i.optionId"
                            :prepend-inner-icon="i.inputType=='time' ? 'mdi-clock-outline' : 'mdi-calendar'"
                            outlined
                            dense
                            hide-details
                            readonly
                            v-bind="attrs"
                            @click="i.editableByUser && openMenu(i.optionId)"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="i.inputType=='time'"
                          v-model="i.value"
                          format="24hr"
                          @click:minute="save2(i.value, i.optionId); i._menu=false"
                        ></v-time-picker>
                        <v-date-picker
                          v-else-if="i.inputType=='date'"
                          v-model="i.value"
                          no-title
                          @input="save2(i.value, i.optionId); i._menu=false"
                        ></v-date-picker>
                        <v-date-picker
                          v-else
                          v-model="i._datePart"
                          no-title
                          @input="i._menu2=true"
                        >
                          <v-spacer></v-spacer>
                          <v-time-picker
                            v-if="i._menu2"
                            v-model="i._timePart"
                            format="24hr"
                            @click:minute="i.value=(i._datePart||'')+'T'+(i._timePart||''); save2(i.value, i.optionId); i._menu=false; i._menu2=false"
                          ></v-time-picker>
                        </v-date-picker>
                      </v-menu>
                      <v-text-field 
                        v-else 
                        counter
                        :label="i.description"
                        :name="i.optionId"
                        @input.native="save"
                        outlined
                        :reverse="i.dataType!='nvarchar'"
                        v-model="i.value"
                        persistent-placeholder
                        hide-details
                        :readonly="!i.editableByUser"
                      >
                      </v-text-field>
                  </v-col>
                  <template v-else>
                    <v-col cols="8" class="d-flex align-center">
                      {{i.description}}
                    </v-col>
                    <v-col cols="3" class="d-flex justify-end">
                      <template v-if="i.inputType=='switch'">
                        <v-switch
                          color="info"
                   
                          v-model="i.value"
                          inset
                          :name="i.optionId"
                          @change="save2($event, i.optionId)"
                          :label="i.value?'Si':'No'"
                          hide-details
                          :readonly="!i.editableByUser"
                          class="mt-0 pt-0"
                        ></v-switch>                      
                      </template>
                      <template v-else-if="i.inputType=='date' || i.inputType=='datetime' || i.inputType=='time'">
                        <v-menu
                          :ref="'menu_'+i.optionId"
                          v-model="i._menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                          :disabled="!i.editableByUser"
                          eager
                        >
                          <template v-slot:activator="{ attrs }">
                            <v-text-field
                              v-model="i.value"
                              :name="i.optionId"
                              :prepend-inner-icon="i.inputType=='time' ? 'mdi-clock-outline' : 'mdi-calendar'"
                              outlined
                              dense
                              hide-details
                              readonly
                              v-bind="attrs"
                              @click="i.editableByUser && openMenu(i.optionId)"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="i.inputType=='time'"
                            v-model="i.value"
                            format="24hr"
                            @click:minute="save2(i.value, i.optionId); i._menu=false"
                          ></v-time-picker>
                          <v-date-picker
                            v-else-if="i.inputType=='date'"
                            v-model="i.value"
                            no-title
                            @input="save2(i.value, i.optionId); i._menu=false"
                          ></v-date-picker>
                          <v-date-picker
                            v-else
                            v-model="i._datePart"
                            no-title
                            @input="i._menu2=true"
                          >
                            <v-spacer></v-spacer>
                            <v-time-picker
                              v-if="i._menu2"
                              v-model="i._timePart"
                              format="24hr"
                              @click:minute="i.value=(i._datePart||'')+'T'+(i._timePart||''); save2(i.value, i.optionId); i._menu=false; i._menu2=false"
                            ></v-time-picker>
                          </v-date-picker>
                        </v-menu>
                      </template>
                      <template v-else>
                        <v-text-field   
                          counter
                          label=""
                          :name="i.optionId"
                          outlined
                          @input.native="save"
                          :reverse="i.dataType!='nvarchar'"
                          :stlye="i.dataType=='int'?'max-width:100px':''"
                          v-model="i.value"
                          persistent-placeholder
                          hide-details
                          :readonly="!i.editableByUser"
                        >
                        </v-text-field>                          
                      </template>
                    </v-col>
                  <v-col cols="1" class="d-flex align-center">
                    <v-tooltip max-width="250" top :disabled="!i.help&&!i.editableByUser" v-if="i.help">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                      </template>
                      <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                    </v-tooltip>                          
                  </v-col>                                                
                </v-row>
                  </v-card>
                </template><!-- end WA_DB_grouped -->
              </v-card>              
              <v-card class="neu-glow mt-7 pb-3" :class="$vuetify.breakpoint.xlAndUp?'mb-3':'my-3'">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Altri Parametri Prenotazione Online
                </v-card-title>

                <template v-for="(group, gi) in WA_DBS_grouped">
                  <v-card outlined :key="'grp'+gi" class="ma-1 py-3">
                  <v-row class="mx-2" v-for="(i,ii) in group.items" :key="group.path+'_'+ii">
                  
                  <v-col cols="11" v-if="i.dataType=='nvarchar'" class="d-flex align-center">  
                      <v-textarea 
                        v-if="i.inputType=='textarea'"
                        counter
                        :label="i.description"
                        :name="i.optionId"
                        @input.native="save"
                        outlined
                        auto-grow
                        :reverse="i.dataType!='nvarchar'"
                        v-model="i.value"
                        persistent-placeholder
                        hide-details
                        :readonly="!i.editableByUser"
                      >
                      </v-textarea>
                      <v-select
                        v-else-if="i.inputType=='select'"
                        :label="i.description"
                        :name="i.optionId"
                        :items="i.acceptedValues ? i.acceptedValues.split(',').map(v => v.trim()) : []"
                        v-model="i.value"
                        outlined
                        dense
                        hide-details
                        :readonly="!i.editableByUser"
                        @change="save2($event, i.optionId)"
                      ></v-select>
                      <v-select
                        v-else-if="i.inputType=='multiselect'"
                        :label="i.description"
                        :name="i.optionId"
                        :items="i.acceptedValues ? i.acceptedValues.split(',').map(v => v.trim()) : []"
                        v-model="i.value"
                        outlined
                        dense
                        hide-details
                        multiple
                        chips
                        small-chips
                        :readonly="!i.editableByUser"
                        @change="save2(Array.isArray($event) ? $event.join(',') : $event, i.optionId)"
                      ></v-select>
                      <v-menu
                        v-else-if="i.inputType=='date' || i.inputType=='datetime' || i.inputType=='time'"
                        :ref="'menu_'+i.optionId"
                        v-model="i._menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        :disabled="!i.editableByUser"
                        eager
                      >
                        <template v-slot:activator="{ attrs }">
                          <v-text-field
                            v-model="i.value"
                            :label="i.description"
                            :name="i.optionId"
                            :prepend-inner-icon="i.inputType=='time' ? 'mdi-clock-outline' : 'mdi-calendar'"
                            outlined
                            dense
                            hide-details
                            readonly
                            v-bind="attrs"
                            @click="i.editableByUser && openMenu(i.optionId)"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="i.inputType=='time'"
                          v-model="i.value"
                          format="24hr"
                          @click:minute="save2(i.value, i.optionId); i._menu=false"
                        ></v-time-picker>
                        <v-date-picker
                          v-else-if="i.inputType=='date'"
                          v-model="i.value"
                          no-title
                          @input="save2(i.value, i.optionId); i._menu=false"
                        ></v-date-picker>
                        <v-date-picker
                          v-else
                          v-model="i._datePart"
                          no-title
                          @input="i._menu2=true"
                        >
                          <v-spacer></v-spacer>
                          <v-time-picker
                            v-if="i._menu2"
                            v-model="i._timePart"
                            format="24hr"
                            @click:minute="i.value=(i._datePart||'')+'T'+(i._timePart||''); save2(i.value, i.optionId); i._menu=false; i._menu2=false"
                          ></v-time-picker>
                        </v-date-picker>
                      </v-menu>
                      <v-text-field 
                        v-else 
                        counter
                        :label="i.description"
                        :name="i.optionId"
                        @input.native="save"
                        outlined
                        :reverse="i.dataType!='nvarchar'"
                        v-model="i.value"
                        persistent-placeholder
                        hide-details
                        :readonly="!i.editableByUser"
                      >
                      </v-text-field>
                  </v-col>
                  <template v-else-if="i.inputType=='notCompliant'">
                    <v-col  class="d-flex align-center">
                      {{i.description}}
                    </v-col>
                    <div class="py-3">
                      <v-select
                        :value="bitsToArray(i.value)"
                        :items="notCompliantOptions"
                        item-text="label"
                        item-value="value"
                        multiple
                        chips
                        small-chips
                        outlined
                        dense
                        hide-details
                        :readonly="!i.editableByUser"
                        @change="saveBits($event, i)"
                      ></v-select>
                    </div>
                    <v-col cols="1" class="d-flex align-center">
                      <v-tooltip max-width="250" top v-if="i.help">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                        </template>
                        <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                      </v-tooltip>                          
                    </v-col>                      
                  </template>
                  <template v-else-if="i.inputType=='highchairsByDoW'">
<!-- Horizontal Day Pillars -->
    <div class="d-flex justify-space-between align-center py-6" style="width:80%">
      <div class="pl-3">Seggiolini Selezionabili per giorno della settimana</div>
      <div
        v-for="(day, index) in days"
        :key="day.key"
        class="d-flex flex-column align-center ga-2"
      >
        <!-- Day Circle with Floating Badge -->
        <v-badge
          :content="getDayValue(i, index)"
          :value="getDayValue(i, index) > -1"
          :color="getDayValue(i, index) > 0 
              ? 'success px-2' 
              : 'warning px-2 black--text text--darken-1 border-muted'"
          overlap
          offset-x="42"
          offset-y="62"
        >
          <div
            style="border-radius:15px"
            :class="[
              'day-circle d-flex align-center justify-center pb-5 font-weight-bold transition-fast-in-fast-out ml-3',
              getDayValue(i, index) > 0 
                ? 'success px-2' 
                : 'warning px-2 black--text text--darken-1 border-muted'
            ]"
          >
            {{ day.short }}
          </div>
        </v-badge>

        <!-- Micro Stepper Buttons below the day circle -->
        <div class="d-flex align-center ga-1 mt-1">
          <v-btn
            icon
            small
            elevation="0"
            color="error"
            class="error"
            :disabled="getDayValue(i, index) <= 0"
            @click="setDayValue(i, index, -1)"
          >
            <v-icon small  class="black--text">mdi-minus</v-icon>
          </v-btn>

          <v-btn
            icon
            small
            elevation="0"
            color="success"
            class="success"
            :disabled="getDayValue(i, index) >= maxAllowed"
            @click="setDayValue(i, index, 1)"
          >
            <v-icon small class="black--text">mdi-plus</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
                  </template>
                  <template v-else>
                    <v-col  class="d-flex align-center">
                      {{i.description}}
                    </v-col>
                    <v-col cols="3" class="d-flex justify-end">
                      <template v-if="i.inputType=='switch'">
                        <v-switch
                          color="info"
                          v-model="i.value"
                          inset
                          :name="i.optionId"
                          @change="save2($event, i.optionId)"
                          :label="i.value?'Si':'No'"
                          hide-details
                          :readonly="!i.editableByUser"
                          class="mt-0 pt-0"
                        ></v-switch>
                      </template>
                      <template v-else-if="i.inputType=='date' || i.inputType=='datetime' || i.inputType=='time'">
                        <v-menu
                          :ref="'menu_'+i.optionId"
                          v-model="i._menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                          :disabled="!i.editableByUser"
                          eager
                        >
                          <template v-slot:activator="{ attrs }">
                            <v-text-field
                              v-model="i.value"
                              :name="i.optionId"
                              :prepend-inner-icon="i.inputType=='time' ? 'mdi-clock-outline' : 'mdi-calendar'"
                              outlined
                              dense
                              hide-details
                              readonly
                              v-bind="attrs"
                              @click="i.editableByUser && openMenu(i.optionId)"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="i.inputType=='time'"
                            v-model="i.value"
                            format="24hr"
                            @click:minute="save2(i.value, i.optionId); i._menu=false"
                          ></v-time-picker>
                          <v-date-picker
                            v-else-if="i.inputType=='date'"
                            v-model="i.value"
                            no-title
                            @input="save2(i.value, i.optionId); i._menu=false"
                          ></v-date-picker>
                          <v-date-picker
                            v-else
                            v-model="i._datePart"
                            no-title
                            @input="i._menu2=true"
                          >
                            <v-spacer></v-spacer>
                            <v-time-picker
                              v-if="i._menu2"
                              v-model="i._timePart"
                              format="24hr"
                              @click:minute="i.value=(i._datePart||'')+'T'+(i._timePart||''); save2(i.value, i.optionId); i._menu=false; i._menu2=false"
                            ></v-time-picker>
                          </v-date-picker>
                        </v-menu>
                      </template>                   
                      <template v-else>
                        <v-text-field   
                          counter
                          dense
                          label=""
                          :name="i.optionId"
                          outlined
                          @input.native="save"
                          :reverse="i.dataType!='nvarchar'"
                          :stlye="i.dataType=='int'?'max-width:100px':''"
                          v-model="i.value"
                          persistent-placeholder
                          hide-details
                          :readonly="!i.editableByUser"
                        >
                        </v-text-field>                          
                      </template>
                    </v-col>
                  <v-col cols="1" class="d-flex align-center">
                    <v-tooltip max-width="250" top v-if="i.help">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                      </template>
                      <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                    </v-tooltip>                          
                  </v-col>                                                
                </v-row>
                  </v-card>
                </template><!-- end WA_DBS_grouped -->
              </v-card>                            
            </v-col>
            <v-col cols="12" lg="6" class="order-0 order-xl-0">
              <v-card class="neu-glow mb-3">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Immagini Form Prenotazione Online
                </v-card-title>
                <v-row class="mx-2" >
                    <v-col cols="12" lg="6" class="py-1" v-for="(i,ii) in WA_DB.filter(w=>w.optionId.includes('logo'))" :key="ii">
                      <div>{{i.description}}</div> 


                      <template>
                        <v-col class="d-flex align-center"> 
                          <v-hover v-slot="{ hover }">
                          <v-card 
                            :elevation="hover ? 12 : 2"
                            class="mt-2 mb-2 item" 
                            color="grey lighten-4"
                            :class="{ 'on-hover': hover }"
                            flat
                          >                            
                            <v-img 
                              v-if="i.value"
                              class="elevation-8" 
                              :key="ii" 
                              :src="'/static/users/pictures/'+i.path+'/'+i.value" 
                              :lazy-src="'/static/users/pictures/'+i.path+'/'+i.value"
                              :style="!i.optionId.endsWith('W')?'background-color:#FFF':''"
                            >
                            </v-img>

                        <v-img 
                          v-else
                          class="elevation-8 mb-3" :key="ii" 
                          src="/static/users/pictures/db/empty_200_70.png"
                          lazy-src="/static/users/pictures/db/empty_200_70.png" 

                          :style="!i.optionId.endsWith('W')?'background-color:#FFF':''"
                        >
                        </v-img>

                            

                            <div style="position:absolute;top:15%;left:75%;transform:translate(-20%,-50%);">
                                <v-tooltip top>
                                      <template v-slot:activator="{ attrs }">
                                        <v-icon
                                          v-bind="attrs" v-on="on"
                                          class="v-icon2 info--text mr-3"
                                          large
                                          :class="{ 'show-btn': hover }"
                                          @click="setPictureName(i)"
                                        >
                                          mdi-image-edit
                                        </v-icon>
                                      </template>
                                      <div>Cambia Immagine</div>
                                </v-tooltip>   
                                <v-tooltip top>
                                      <template v-slot:activator="{ attrs }">
                                        <v-icon
                                          v-bind="attrs" v-on="on"
                                          class="v-icon2 warning--text"
                                          large
                                          :class="{ 'show-btn': hover}"
                                         @click="restoreImage(i)"
                                        >
                                          mdi-image-remove
                                        </v-icon>
                                      </template>
                                      <div>Ripristina Immagine Precedente</div>
                                </v-tooltip>                                                                     
                              </div>
                            </v-card>


                          </v-hover>
                        </v-col>
                      </template>                      
                  </v-col>
                </v-row>
              </v-card>              
              <v-card class="neu-glow mb-3">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Immagini Slide Prenotazione Online
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="addSlide()">
                        <v-icon color="success">mdi-image-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Inserisci Immagine</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text>
                  Le immagini verranno mostrate nella seguente Sequenza: Trascina le Immagini per modificare la Sequenza
                </v-card-text>                 
                <template v-if="slidePictures">
                  <v-row class="mx-2" >
                    <template>

                      <draggable 
                        v-model="slidePictures" 
                        class="row" 
                        animation="600" 
                        :class="{ 'draggable-drag': isDragging }"
                        @end="onDragEndSlidePictures()" 
                        @start="isDragging = true" 
                      >
                      <v-col cols="12" sm="6" v-for="(item,ii) in slidePictures" :key="item">
                        <v-hover v-slot="{ hover }">
                          <v-card 
                            :elevation="hover ? 12 : 2"
                            class="mt-2 mb-2 item" 
                            color="grey lighten-4"
                            :class="{ 'on-hover': hover }"
                            flat
												
                          >
                            <img 
                              class="elevation-8 mb-3" 
                              :src="'/static/users/pictures/slides/'+item"
                              loading="lazy"
                              style="width:100%;height:auto;display:block"
                            >
                            <div class="text-h1" :style="'position:absolute;top:35%;left:40%;opacity:'+hover">
                                  {{ii+1}}
                            </div>
                            <div style="position:absolute;top:10%;left:10%;transform:translate(-50%,-50%);">
                              <v-tooltip top>
                                    <template v-slot:activator="{ attrs }">
                                      <v-icon
                                        v-bind="attrs" v-on="on"
                                        class="v-icon2 success--text"
                                        large
                                        :class="{ 'show-btn': hover }"
                                      >
                                        mdi-cursor-move
                                      </v-icon>
                                    </template>
                                    <div>Sposta Immagine</div>
                              </v-tooltip>
                            </div>  
                            <div style="position:absolute;top:10%;left:90%;transform:translate(-50%,-50%);">
                              <v-tooltip top>
                                    <template v-slot:activator="{ attrs }">
                                      <v-icon
                                        v-bind="attrs" v-on="on"
                                        class="v-icon2 error--text"
                                        large
                                        :class="{ 'show-btn': hover }"
                                        @click="removeSlideImage(item)"
                                      >
                                        mdi-delete
                                      </v-icon>
                                    </template>
                                    <div>Rimuovi Immagine</div>
                              </v-tooltip>                                     
                            </div>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </draggable>
                    </template>
                  </v-row>
                </template>

              </v-card>              
            </v-col>             
            <!--</masonry-wall>-->
          </v-row>
        </v-card>
    </v-form>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              WhatsApp: Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>              
            <v-row class="mx-5 mb-0">
                <v-col md="12" cols="12">
                    <p>
                      l'Hostname è l'indirizzo al quale i vostri clienti potranno effettuare le prenotazioni ma anche il punto di ingresso all'App:
                    <br />
                      come default utilizza il nome del vostro sito (o il nome del vostro locale) che avete indicato in fase di registrazione: qualora non sia stato fornito utilizza una stringa casuale (che può comunque essere modificata<sup>1</sup> da questa pagina):
                    </p>
                    <p>
                      Ipotizziamo ad esempio, che il vostro locale si chiami <strong>Arcadia</strong> e/o il vostro sito sia <strong>www.arcadia.it</strong>, il sistema vi attribuirà di default il seguente hostname: <strong>arcadia.jslab.it</strong>
                    </p>
                    <p>
                      E' disponibile, a fronte di un contributo di configurazione una tantum di 100 €, una soluzione del tipo <strong>booking.arcadia.it</strong> (o <strong>qualsiasicosa.arcadia.it</strong>)
                    </p>
                    <p>In quest caso è necessario che:
                      <ul>
                        <li>
                          Creiate un nuovo hostname e lo denominiate come meglio credete, nell'esempio <strong>booking.arcadia.it</strong>
                        </li>
                        <li>
                          Se non avete già un sito, lo registriamo noi a Vostro nome<sup>2</sup>
                          Se invece avete già un sito, inseriate il recapito di colui che gestisce il nome a dominio <strong>arcadia.it</strong> che contatteremo per le necessarie modifiche.
                          <br />In pratica gli chiederemo di creare il sottodominio <strong>booking</strong> e farlo puntare all'indirizzo <strong>84.247.8.202</strong>.
                          <br />(Più tecnicamente creare il seguente DNS Record: <strong>booking 60 IN A 84.247.8.202</strong>)
                        </li>  
                      </ul>
                    <p>
                      Non appena le impostazioni si saranno propagate (il tempo canonico è 24 ore) provvederemo ad apportare le necessarie modifiche di configurazione e l'indirizzo sarà attivo
                    </p>
                    <p>
                      <sup>1</sup>Se non è già utilizzato
                      <sup>2</sup>(dall'anno successivo vi verrà addebitato un canone di 30.00€)
                      </p>
                </v-col>
            </v-row>

        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_vuecropper" max-width="1100">
      <vuecropper 
        v-if="UFD"
        @close="closeCropper"
        @completed="handleCompleted"
        @error="handlerError"
        :uploadFormData="UFD"
      >
      </vuecropper>
    </v-dialog> 	
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import AvatarCropper from "../AvatarCropper";
import vuecropper from "../VueCropper";
import draggable from 'vuedraggable';
import _ from 'lodash'
export default {
  components: { vuecropper, draggable },
  data() {
    return {
      page: "Settings",
      form:{},
      maxAllowed: 10,
      snackbar:false,
      snackbar_color:null,
      snackbar_message:null,
      loading:false,
      loading_update:false,
      loading_refresh:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_edit:false,
      dialog_instruction:false,
      dialog_vuecropper:false,
      templates_hash:null,
      templates:null,
      subdomain:null,
      UFD:null,
      classes:null,
      items:null,
      notCompliants:[],
      slidePictures:null,
      isDragging: false,
      dialog_connection_error: false,
      //pictureType:null,
      editedItem:{},
      uploadURL:'./ajax/settings/upload.php',
      cropperOptions:[
                      {aspectRatio: 1.5, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true},
                      {aspectRatio: 4, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true}
                     ],
      outputOptions: [
                        {
                        width: 420,
                        height: 240,
                        minWidth: 420,
                        minHeight: 240,
                        maxWidth: 420,
                        maxHeight: 240,
                        imageSmoothingEnabled: true,
                        imageSmoothingQuality: 'high',
                      },
                      {
                        width: 280,
                        height: 70,
                        minWidth: 280,
                        minHeight: 70,
                        maxWidth: 280,
                        maxHeight: 70,
                        imageSmoothingEnabled: true,
                        imageSmoothingQuality: 'high',
                      }
                    ],      
      pictureName:null,
      pictureNameW:null,
      pictureNameRoot:null,
      pictureNameRootW:null,
      optionId:null,
      changedLogo:false,
      
      selectedTemplate:null,
      brand:null,
      inputFields:[],
      default:{"fullName":"Mario Rossi","day":"Sabato 18 Giugno","time":"20:30","guests":"5+1 Seggiolone","brand":this.brand},
      WA_DB:null,
      WA_DBS:null,
      WA_DBSL:null,
      notCompliantOptions: [
        { label: 'Coperti', value: 1},
        { label: '1P/2P/3P', value: 2 },
        { label: 'PMax', value: 4 },
        { label: 'Adulti x 1 B', value: 8 },
        { label: 'Valutazione Negativa', value: 16 }
      ],
      days: [
        { key: 'lun', short: 'LU', label: 'Lunedì' },
        { key: 'mar', short: 'MA', label: 'Martedì' },
        { key: 'mer', short: 'ME', label: 'Mercoledì' },
        { key: 'gio', short: 'GI', label: 'Giovedì' },
        { key: 'ven', short: 'VE', label: 'Venerdì' },
        { key: 'sab', short: 'SA', label: 'Sabato' },
        { key: 'dom', short: 'DO', label: 'Domenica' }
      ],
      dayValues: [0, 0, 0, 0, 0, 0, 0]
    };
  },
  
  computed : {
    ...mapGetters(["settings"]),
    totalValue() {
      return this.notCompliants.reduce((sum, val) => sum + val, 0);
    },
    /** Groups WA_DB items by i.path, preserving order */
    WA_DB_grouped() {
      if (!this.WA_DB) return []
      const groups = []
      let currentPath = null
      this.WA_DB.filter(w => w.optionId.substring(0, 4) !== 'logo').forEach(item => {
        if (item.path !== currentPath) {
          groups.push({ path: item.path || '', items: [] })
          currentPath = item.path
        }
        groups[groups.length - 1].items.push(item)
      })
      return groups
    },

    /** Groups WA_DBS items by i.path, preserving order */
    WA_DBS_grouped() {
      if (!this.WA_DBS) return []
      const groups = []
      let currentPath = null
      this.WA_DBS.forEach(item => {
        if (item.path !== currentPath) {
          groups.push({ path: item.path || '', items: [] })
          currentPath = item.path
        }
        groups[groups.length - 1].items.push(item)
      })
      return groups
    },
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
  },
  methods:
  {
    getDayValue(item, index) {
      if (!item || !item.value) return 0;
      const parts = String(item.value).split(',');
      return parseInt(parts[index], 10) || 0;
    },
    setDayValue(item, index, delta) {
      const parts = String(item.value || '0,0,0,0,0,0,0').split(',');
      while (parts.length < 7) parts.push('0');
      const current = parseInt(parts[index], 10) || 0;
      parts[index] = String(Math.max(0, Math.min(this.maxAllowed, current + delta)));
      const newStr = parts.join(',');
      this.$set(item, 'value', newStr);
      this.save2(newStr, item.optionId);
    },    
    // GETTER: Checks if the specific bit is active in the bitmask
  isBitActive(mask, bit) {
    return !!(mask & bit)
  },
    // NEW: turn a bitmask into the array of matching option values, e.g. 5 -> [1,4]
  bitsToArray(mask) {
    return this.notCompliantOptions
      .filter(o => this.isBitActive(mask, o.value))
      .map(o => o.value)
  },

  // NEW: turn the v-select's array back into a bitmask and save
  saveBits(selected, item) {
    const newValue = selected.reduce((acc, bit) => acc | bit, 0)
    this.$set(item, 'value', newValue)
    this.save2(newValue, item.optionId)
  }, 
    openMenu(optionId) {
      this.$nextTick(() => {
        const ref = this.$refs['menu_' + optionId]
        if (ref) {
          const menu = Array.isArray(ref) ? ref[0] : ref
          menu.isActive = true
        }
      })
    },
    onDragEndSlidePictures()
    {
      //console.log(556,event)
      //console.log('Moved from:', event.oldIndex, 'to:', event.newIndex);
      this.WA_DB.find(w=>w.optionId=='carouselImages').value=this.slidePictures;
      this.save2(this.slidePictures.toString(), 'carouselImages')
    },    
    addSlide()
    {
      //console.log(397,i);
      //this.pictureType=i.optionId.includes('TB')?'tb':'db';
      this.path='slides';
      var name='_'+(this.slidePictures.length/1+1/1)+'.jpg';
      var optionId='carouselImages'

      
      this.UFD={'name':name,'type':this.path,'subdomain':this.subdomain,'optionId':optionId,'width':1120,'height':630}
      console.log(409,this.UFD)
      this.dialog_vuecropper=true

    },    
    removeSlideImage(i)
    {
      console.log(507,i)
      //var option=this.WA_DB.find(f=>f.optionId=='carouselImages').value;
      var newValue=this.slidePictures.filter(s=>s!==i)
      console.log(590,newValue);
      //tmp=tmp.split(',').filter(img => img !== i).join(',')
      //this.WA_DB.find(f=>f.optionId=='carouselImages').value=tmp;
      this.$set(this.WA_DB.find(f=>f.optionId=='carouselImages'), 'value', newValue)
      //this.WA_DB.filter(f=>f.optionId==s.carouselImages=this.WA_DB.options.carouselImages.split(',').filter(img => img !== i).join(','); 
      console.log(595,newValue)
      this.save2(newValue.toString(), 'carouselImages')
      this.slidePictures=newValue
    },
    closeCropper()
    {
      this.dialog_vuecropper=false;
      this.UFD=null;
    },
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message=response.message;
        this.pictureName=response.pictureName;
        console.log(397,this.pictureName)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
      this.dialog_vuecropper=false;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, message, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },         
    setPictureName(i)
    {
      console.log(397,i);
      //this.pictureType=i.optionId.includes('TB')?'tb':'db';
      this.pictureNameRoot=i.value.split('-')[1];
      this.optionId=i.optionId;
      this.path=i.path;
      this.pictureName=i.value.split('-')[1];
      
      this.UFD={'name':i.value,'type':i.path,'subdomain':this.subdomain,'optionId':i.optionId,'width':i.size.split('x')[0],'height':i.size.split('x')[1]}
      console.log(409,this.UFD)
      this.dialog_vuecropper=true

    },
    save: _.debounce(function (event) {
      console.log(400,event.target.name,event.target.value)
      var n=event.target.name
      var v=event.target.value
      var value=null;
      console.log(1004,n,v)
      if(n=='disableSameDayDirectBooking')
      {
        value=v===false?null:new Intl.DateTimeFormat('en-CA').format(new Date());
      }
      else
      {
        value=v===false?0:v===true?1:v===''?null:v
      }
      console.log(1008,n,v,value)
      var pload={"optionId":event.target.name,"value":value};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(406,payload)
      this.updateDB(payload)
    }, 1000),
    save2(value, field, oValue=null) {
      console.log(400,value,field,oValue)
      var pload=null;
      if(field=='manuallyConfirmNotCompliant')
      {
        var value2=this.WA_DBS.find(w=>w.optionId==field).value/1;
        console.log(403,value2,oValue)
        //value=value.reduce((acc, num) => acc + num, 0)
        if (value) {
        // Box was checked: Add the value using Bitwise OR (|)
          value2 |= oValue;
        } else {
          // Box was unchecked: Remove the value using Bitwise AND + NOT (~ &)
          value2 &= ~oValue;
        }
        console.log(405, value2,value)
        //value=value2; 
        this.WA_DBS.find(w=>w.optionId==field).value=value2;
        pload={"optionId":field,"value":value2};
      }
      else
      {
        pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      }
      console.log(409,value, field,oValue);
      
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(413,payload)
      this.updateDB(payload)
    },    
    async restoreImage(i)
    {
      console.log(427,i);
      this.loading_update=true;
      var action='saveItem';
      var pload={"optionId":i.optionId};
      let payload={"action":action,"table":"User_Options_Restore","payload":pload};
      console.log(413,payload)
      let z= await this.updateDB(payload)
      this.loading_update=false;
      console.log(416,z);
      if(z.errorid=='0')
      {
          this.snackbar_color="success"
          this.message =z.message;
          this.snackbar = true;
          //console.log(422,w.payloads.ivalue)
          this.WA_DB.find(w=>w.optionId==i.optionId).value=z.payloads.ivalue;
          //this.pictureName=z.payloads.ivalue
          //this.dialog_editOption=false;
          //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
      }

    },
    handleUploading({ form, request }) {
      // show a loader
      console.log(384, {form, request})
    },/*
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message='Modificato Logo';
        this.pictureName=response.pictureName;
        this.WA_DB.find(w=>w.optionId==response.optionId).value=response.pictureName;
        console.log(397,this.pictureName)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, form, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },*/
    editItem(f)
    {
      if (f)
      {
        this.editedItem=f
      }
      else
      {
        this.editedItem={};
        this.editedItem_hash=JSON.stringify(this.editedItem)
      }
      console.log(214,f,this.editedItem)
      this.dialog_edit=true;
    }, 
    editOption(f)
    {
      this.editedOption=f;
      console.log(214,f)
      this.dialog_edit=true;
    },
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllDirectBookingOptions_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                this.loading=false;
                switch (res.data.errorid)
                {
                  case '0':
                      console.log(745,res, res.data.payloads.WA_DB)
                      var tmp=res.data.payloads.WA_DB;
                      console.log(746,tmp);
                      var tmp2=tmp.find(w=>w.optionId=='carouselImages')
                      console.log(748,tmp2);
                      var tmp3=tmp2 ? tmp2.value : null;
                      console.log(750,tmp3);
                      if (tmp3)
                      {
                        var tmp4=tmp3.split(',');
                        this.slidePictures=tmp4;//res.data.payloads.WA_DB.find(w=>w.optionId=='carouselImages').value.split(',')
                        console.log(753, this.slidePictures)  
                      }
                      else
                      {
                        this.slidePictures=[];
                      }

                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.brand = res.data.payloads.WA_Brand ? res.data.payloads.WA_Brand.brand : null;
                      this.subdomain = res.data.payloads.WA_Subdomain ? res.data.payloads.WA_Subdomain.subdomain : null;
                      //this.WA_DB=res.data.payloads.WA_DB.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); o._menu=false; o._menu2=false; return o});
                      //this.WA_DBS=res.data.payloads.WA_DBS.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); o._menu=false; o._menu2=false; return o});
                      //this.WA_DBSL=res.data.payloads.WA_DBSL.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); o._menu=false; o._menu2=false; return o});
                      this.WA_DB = res.data.payloads.WA_DB.map(o => {
                        o.value = o.value === '1' && o.dataType == 'bit' ? true
                                : (o.value === '0' && o.dataType == 'bit' ? false : o.value);
                        if (o.inputType === 'multiselect' && o.value) {
                          o.value = o.value.split(',').map(v => v.trim()).filter(v => v)
                        }
                        o._menu = false;
                        o._menu2 = false;
                        return o
                      });

                      this.WA_DBS = res.data.payloads.WA_DBS.map(o => {
                        o.value = o.value === '1' && o.dataType == 'bit' ? true
                                : (o.value === '0' && o.dataType == 'bit' ? false : o.value);
                        if (o.inputType === 'multiselect' && o.value) {
                          o.value = o.value.split(',').map(v => v.trim()).filter(v => v)
                        }
                        o._menu = false;
                        o._menu2 = false;
                        return o
                      });

                      this.WA_DBSL = res.data.payloads.WA_DBSL.map(o => {
                        o.value = o.value === '1' && o.dataType == 'bit' ? true
                                : (o.value === '0' && o.dataType == 'bit' ? false : o.value);
                        if (o.inputType === 'multiselect' && o.value) {
                          o.value = o.value.split(',').map(v => v.trim()).filter(v => v)
                        }
                        o._menu = false;
                        o._menu2 = false;
                        return o
                      });

                      {
                        const hcItem = this.WA_DBS.find(w => w.optionId === 'highchairsByDoW');
                        console.log(1301,hcItem);
                        if (hcItem && hcItem.value) {
                          String(hcItem.value).split(',').forEach((v, i) => {
                            this.$set(this.dayValues, i, parseInt(v.trim(), 10) || 0);
                          });
                        }
                        console.log(1305,this.dayValues);
                      }
                      //this.items=res.data.payloads.items;
                      /*this.pictureName=this.WA_Options.find(o=>o.optionId=='TDB_Logo').value;
                      this.pictureNameW=this.WA_Options.find(o=>o.optionId=='TWDB_Logo').value;
                      this.pictureNameRoot=this.pictureName.split('-')[1];
                      this.pictureNameRootW=this.pictureNameW.split('-')[1];  
                      */
                     //this.classes=[...new Set( this.items.map(obj => obj.class)) ];
                     //this.classes=["WA_DB","WA_DBS","WA_DBSL"];                    
                      //console.log(486,this.brand,this.WA_DB,this.WA_DBS,this.subdomain),this.items,this.classes;
                      //console.log(487,this.pictureName,this.pictureNameW,this.pictureNameRoot,this.pictureNameRootW)
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
            } catch(e)
            {
                this.loading= false;
                this.loading_refresh=false;
                this.dialog_connection_error=true;
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;

              if (res.data.message)
              {
                  console.log(333);
                  this.snackbar_color=res.data.status=='OK'?'success':'error';
                  this.snackbar_message=res.data.message;
                  this.snackbar=true;
              }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>
<style>
.v-card--reveal {
align-items: center;
bottom: 0;
justify-content: center;
opacity: .75!important;
position: absolute;
width: 100%;
}

.v-card .v-image {
  transition: filter .4s ease-in-out;
}

.v-card.on-hover .v-image {
  filter: brightness(30%);
}

.v-icon2 {
  opacity: 0;
  background-color: transparent !important;
  transition: opacity .4s ease-in-out;
}

.show-btn {
  opacity: 1;
}

.draggable-drag {
  cursor: grabbing !important;
}
</style>
<style scoped>
.day-circle {
  width: 64px;
  height: 64px;
  font-size: 1.15rem;
}

.border-primary {
  border: 2px solid var(--v-primary-base, #1976d2);
}

.border-muted {
  border: 2px solid #e0e0e0;
}

.ga-1 {
  gap: 4px;
}

.ga-2 {
  gap: 8px;
}
</style>